import React from "react";

const PrimaryHeading = ({ children }) => {
  
  return (
    <div className="flex items-center">
      <div className="h-12 border-primary w-8 border-l-[3px] border-y-[3px] rounded-l-md -mr-3"></div>
      <h2 className="text-xl text-textColor font-semibold max-sm:text-base text-center ">
        {children}
      </h2>

      <div className="h-12 border-primary w-8 border-r-[3px] border-y-[3px] rounded-r-md -ml-4"></div>
    </div>
  );
};

export default PrimaryHeading;
